export default __webpack_public_path__ + "static/media/logo1.5dc8b4fa.png";